import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';

import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GeneralService } from 'src/app/service/general.service';
import { GetListBO } from './client-parent.model';
import { map } from 'rxjs/operators';
@Injectable()

export class clienttserivcetax extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService, public ngxservice: NgxUiLoaderService) {
    super();
  }

  // ......................................relationship tax percenet.............................................................//
  public executetax(state: GetListBO): void {
    this.getrelationtaxpercentlist(state).subscribe(x => super.next(x));
  }

  getrelationtaxpercentlist(state?: GetListBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClientRelationshipTax/GetEmployerEmpRelTaxPercent", state)
      .pipe(map(
        (response: any) => (<any>{
          count: response['count'],
          result: response['result']

        }))
      )

  }


}
